export default __webpack_public_path__ + "static/media/logo.d7b5f66e.png";